<template>
    <div class="about">
        <TrackingTree />
    </div>
</template>

<script>
    import TrackingTree from '@/components/TrackingTree.vue';
	export default {
		name: 'Tracking',
        components: {TrackingTree},
        data () {
            return {}
        },
	}
</script>